/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ integration: NonNullable<unknown> }} Audit_Details_Project_Link_Required_DescInputs */



/**
* | output |
* | --- |
* | "The {integration} integration's tools were restricted to chats whose project links it." |
*
* @param {Audit_Details_Project_Link_Required_DescInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const audit_details_project_link_required_desc = /** @type {((inputs: Audit_Details_Project_Link_Required_DescInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audit_Details_Project_Link_Required_DescInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Die Werkzeuge der Integration ${i?.integration} wurden auf Chats beschränkt, deren Projekt sie verknüpft.`)
	return /** @type {LocalizedString} */ (`The ${i?.integration} integration's tools were restricted to chats whose project links it.`)
});